// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___uzu36"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/container/styles.css
// module id = Apsl
// module chunks = 2